import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {GetHealthStates, GetHealthStatesModel, GetHealthStatesParams} from 'domain/usecases';
import {APIError} from 'data/errors/api-error';

export class RemoteGetHealthStates implements GetHealthStates {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthStatesModel>,
	) {}

	async get(params?: GetHealthStatesParams): Promise<GetHealthStatesModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal: params?.signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
